import { ID_NUMBER, padZeros } from "./idNumber";

export interface HeadersTable {
    [key: string]: string;
}

export interface attributesInterface {
    [key: string]: string;
}

export const FieldsToHeaders = (fields?: __esri.Field[], excludedHeaders?: string[]) => {
    var headers: HeadersTable = {};

    if (fields !== undefined && fields !== null) {
        fields.forEach((field: __esri.Field) => {
            if (!excludedHeaders?.includes(field.name)) headers[field.name] = field.alias;
        });
    }
    return headers;
}

export const fixId = (featureSet: __esri.FeatureSet) => {
    var hasIdField = featureSet.fields.some(f => f.name === ID_NUMBER);
    if (!hasIdField) {
        return featureSet;
    }
    featureSet.features?.forEach((feature: __esri.Graphic) => {
        feature.attributes[ID_NUMBER] = padZeros(feature.attributes[ID_NUMBER]);
    });
    return featureSet;
}

export const joinData = (data: __esri.Graphic[], primeSelections?: __esri.Graphic[]) => {
    if (!primeSelections || primeSelections.length === 0) {
        return data;
    }
    let cloneFeatureSet = [...data];
    if (primeSelections.length > 1) {
        let existing = 0;
        cloneFeatureSet = cloneFeatureSet.filter(c => {
            const hasItem = primeSelections.some(f => {
                return f.attributes.ID === c.attributes.ID;
            });
            if (hasItem) {
                existing += 1;
            }
            return hasItem === false;
        })
        cloneFeatureSet.unshift(...primeSelections);
        const diff = primeSelections.length - existing;
        if (diff !== 0) {
            cloneFeatureSet.splice(cloneFeatureSet.length - diff, diff);
        }
        return cloneFeatureSet;
    }
    primeSelections.forEach((row: any) => {
        const hasItem = cloneFeatureSet.some(f => {
            return f.attributes.ID === row.attributes.ID;
        })
        if (!hasItem) {
            cloneFeatureSet.unshift(row);
            cloneFeatureSet.pop();
        }
    });
    return cloneFeatureSet;
}